import { Injectable } from '@angular/core';
import { Aggregator } from '@interfaces/aggregator/1.0';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export abstract class AbstractAggregatorService {
  abstract getAggregators(): Observable<Aggregator[]>;
}
